export default __webpack_public_path__ + "static/media/tick.a5f56f20.svg";